<template>
  <v-container>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />

    <v-form ref="form" lazy-validation>
      <v-row align="center">
        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-text-field
            :rules="[rules.required, rules.maxvalue]"
            v-model="userInfo.firstName"
            class="mx-3"
            label="First Name"
            outlined
            dense
            @keyup.enter="submit"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-text-field
            :rules="[rules.required, rules.maxvalue]"
            v-model="userInfo.lastName"
            class="mx-3"
            label="Last Name"
            outlined
            dense
            @keyup.enter="submit"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-text-field
            :rules="[rules.required, rules.maxvalue]"
            v-model="userInfo.email"
            class="mx-3"
            label="Email"
            outlined
            dense
            @keyup.enter="submit"
          ></v-text-field>
        </v-col>

        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-text-field
            :rules="[rules.required, rules.maxvalue]"
            type="password"
            v-model="userInfo.password"
            class="mx-3"
            label="Password"
            outlined
            dense
            @keyup.enter="submit"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-text-field
            :rules="[rules.required, rules.maxvalue, rules.paswordconfirm]"
            type="password"
            v-model="userInfo.passwordConfirm"
            class="mx-3"
            label="Password Confirm"
            outlined
            dense
            @keyup.enter="submit"
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-select
            :rules="[rules.required]"
            v-model="userInfo.langID"
            class="mx-3"
            :items="langList"
            dense
            label="Lang"
            outlined
            item-text="langname"
            item-value="langid"
          ></v-select>
        </v-col>
        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-select
            v-model="userInfo.isAdmin"
            class="mx-3"
            :items="userType"
            outlined
            dense
            label="User Rule"
            item-text="name"
            @change="selectRule"
            item-value="value"
          ></v-select>
        </v-col>
        <v-col cols="12" lg="6" class="pt-0 pb-0">
          <v-autocomplete
            v-model="userInfo.selectedCategories"
            :items="userInfo.selectedCategories"
            outlined
            dense
            :readonly="true"
            chips
            class="mx-3"
            small-chips
            label="Categories"
            multiple
            item-text="categoryname"
            item-value="categoryid"
            @focus="dialogCategoryTree = true"
          ></v-autocomplete>

          <v-row align="center">
            <v-col cols="6" class="pt-0 pb-0">
              <v-switch
                class="mx-3"
                v-model="userInfo.status"
                label="Status"
                color="primary"
                hide-details
              ></v-switch>
            </v-col>

            <v-col cols="6" class="pt-0 pb-0">
              <v-btn
                @click="submit"
                depressed
                color="primary"
                class="float-right mr-3 mt-3"
                :loading="loadingAdd"
              >
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
    <AdminConfirm
      :AdminConfirmDialog="AdminConfirmDialog"
      v-on:closeAdminConfirmDialog="closeAdminConfirmDialog($event)"
    />

    <SelectTreeCategory
      :dialogCategoryTree="dialogCategoryTree"
      v-on:closeCatDialog="closeCategory($event)"
      v-on:closeCatDialogWithCategories="
        closeCatDialogWithCategoriesMethod($event)
      "
    />
  </v-container>
</template>

<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
import AdminConfirm from "@/components/User/AdminConfirm";
import SelectTreeCategory from "@/components/Category/SelectTreeCategory";

export default {
  data() {
    return {
      rules: {
        required: (value) => !!value || "Field required.",
        maxvalue: (value) =>
          value.length <= 32 || "Maximum length is 32 characters",
        maxvaluePhone: (value) =>
          value.length <= 20 || "Maximum length is 20 characters",
        onlynumber: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0) || "Value Only Number",
        paswordconfirm: () =>
          this.userInfo.password == this.userInfo.passwordConfirm ||
          "password not confirm",
      },
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/",
        },
        {
          text: "Users",
          disabled: false,
          to: "/users",
        },
        {
          text: "New User",
          disabled: true,
        },
      ],
      AdminConfirmDialog: false,
      dialogCategoryTree: false,
      loadingAdd: false,
      userInfo: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "11111111",
        password: "",
        passwordConfirm: "",
        langID: "",
        isAdmin: 0,
        status: 1,
        selectedCategories: [],
      },
      langList: [],
      userType: [
        { name: "Admin", value: 1 },
        { name: "User", value: 0 },
      ],
    };
  },

  components: {
    Breadcrumbs,
    AdminConfirm,
    SelectTreeCategory,
  },

  mounted() {
    this.getAllLang();
  },

  methods: {
    submit() {
      if (this.$refs.form.validate() != false) {
        this.loadingAdd = true;
        let DataForm = {
          Param: {
            firstname: this.userInfo.firstName,
            lastname: this.userInfo.lastName,
            email: this.userInfo.email,
            phonenumber: this.userInfo.phoneNumber,
            langid: this.userInfo.langID,
            password: this.userInfo.password,
            status: this.userInfo.status,
            isadmin: this.userInfo.isAdmin,
            category: [],
          },
          API: "/admin/user",
        };
        if (!this.userInfo.selectedCategories == []) {
          for (
            let index = 0;
            index < this.userInfo.selectedCategories.length;
            index++
          ) {
            DataForm["Param"]["category"].push(
              this.userInfo.selectedCategories[index]["categoryid"]
            );
          }
        }
        this.$store
          .dispatch("PostToAPI", DataForm)
          .then((response) => {
            this.$store.dispatch("PushSuccessMsg", response.data.message);
            this.loadingAdd = false;
            this.$router.push({ name: "Users" }).catch(() => {});
          })
          .catch((error) => {
            let errorObj = error.data.data;
            this.loadingAdd = false;
            this.$store.dispatch(
              "PushErrorMsg",
              errorObj[Object.keys(errorObj)[0]][0]
            );
          });
      } else {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      }
    },
    getAllLang() {
      this.$store.dispatch("GetFromAPI", "/admin/lang").then((response) => {
        this.langList = response["data"]["data"];
      });
    },
    closeAdminConfirmDialog(AcceptVal) {
      if (AcceptVal == false) {
        this.userInfo.isAdmin = 0;
      }
      this.AdminConfirmDialog = false;
    },
    selectRule() {
      if (this.userInfo.isAdmin == 1) {
        this.AdminConfirmDialog = true;
      }
    },
    closeCategory() {
      this.dialogCategoryTree = false;
    },
    closeCatDialogWithCategoriesMethod(vals) {
      this.dialogCategoryTree = false;
      this.userInfo.selectedCategories = vals;
    },
  },
};
</script>
